<template>
    <div :class="{ 'admin-link': true, 'conversations': true, 'none': count <= 0}">
        <a href="/systems/conversations" :title="title">
            <icon :class="{ 'unread': unread > 0 }" type="regular" name="faComment" aria-hidden="true" focusable="false" class="nav-icon" title="Messages"></icon>
            <span v-if="count > 0" class="td-circle-badge">{{ count }}</span>
        </a>
    </div>
</template>

<script>
import script from './AdminConversationLink';
    export default script;</script>

<style lang="less">
    @import "./AdminConversationLink.less";
</style>